import { useAppSelector } from '../../data/store';
import ProductImage from '../../../../products/product-image/product-image';
import { IListItem } from '../../../../list-page/interfaces/interfaces';
import ProductTitle from '../../../../products/product-title/product-title';
import ProductListPrices from '../../../../products/product-price/product-list-prices';
import { wishList2ListItem } from '../../data/data-provider';

const SavedForLater = () => {

    const cartData = useAppSelector(store => store.root.cartData);

    return (
        <div>
            <div className="text-xl font-bold text-gray-700 mb-2 mt-6">Saved for later</div>

            <div className="bg-white border rounded pt-6 px-6">
                {
                    cartData.wishListData.map(item => {

                        const product: IListItem = wishList2ListItem(item);

                        return (
                            <div key={ item.skuid } className="text-gray-700 flex flex-col lg:flex-row lg:items-center mb-6">
                                <ProductImage
                                    product={ product }
                                    classes="mr-8 p-4"
                                    style={{
                                        width: '100px'
                                    }}
                                />

                                <div className="flex-1 mr-8 flex flex-col justify-center">
                                    <ProductTitle product={ product } />

                                    <div className="flex my-4 lg:my-0">
                                        <button type="button" className="text-gray-500 mr-4">Add to Cart</button>
                                        <button type="button" className="text-gray-500 mr-4">Save for Later </button>
                                        <button type="button" className="text-gray-500 mr-4">Remove</button>
                                    </div>
                                </div>

                                <div style={{
                                    minWidth: '170px',
                                }}>
                                    <ProductListPrices product={ product } />
                                </div>
                            </div>
                        )
                    })
                }
            </div>
        </div>
    )
};

export default SavedForLater;